var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-w-1/2 lg:tw-w-2/3 tw-hidden md:tw-flex tw-items-center tw-justify-center tw-fixed tw-right-0 tw-h-screen tw-rounded-l-4xl",style:({ 'background-color': `rgb(${_vm.color})` })},[_c('div',{staticClass:"tw-w-3/5 tw-aspect-w-1 tw-aspect-h-1"},[_c('div',{staticClass:"login--background-image tw-bg-center tw-bg-contain",style:({
      'background-image': `url(${_vm.background})`,
    })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }